export default () => {
  const data = {
    event_name: 'click',
    button_name: 'link_terms',
    page_section: 'modal_talk_with',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
